<div class="overlay-container">
    <h1 class="keymaps-title">Keyboard shortcuts</h1>
    <div class="keymaps-wrapper">
        <div class="column-left">
            <ng-container *ngFor="let context of keymaps | keyvalue">
                <div
                    class="context"
                    *ngIf="leftColumn.includes(context.key)">
                    <h1 class="header">{{ context.key }}</h1>
                    <div
                        class="hotkeys"
                        *ngFor="let hotkey of context.value">
                        <div class="info">{{ hotkey.meta?.description }}</div>
                        <div class="combination">
                            <span
                                class="value"
                                [innerHTML]="separateByWord(hotkey.meta?.shortcut)"></span>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
        <div class="column-right">
            <ng-container *ngFor="let context of keymaps | keyvalue">
                <div
                    class="context"
                    *ngIf="rightColumn.includes(context.key)">
                    <h1 class="header">{{ context.key }}</h1>
                    <div
                        class="hotkeys"
                        *ngFor="let hotkey of context.value">
                        <div class="info">{{ hotkey.meta?.description }}</div>
                        <div class="combination">
                            <span
                                class="value"
                                [innerHTML]="separateByWord(hotkey.meta?.shortcut)"></span>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
